import { ComponentType, forwardRef } from 'react';

import {
  Button,
  ButtonProps,
  SvgIconProps,
  Typography as Text,
  Theme,
  WithStyles,
  createStyles,
  emphasize,
  withStyles,
} from '@material-ui/core';

import { RemixiconComponentType } from '@remixicon/react';
import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(1),
      minWidth: 0,
      '&:hover': {
        backgroundColor: emphasize(theme.palette.action.hover, 0.08),
        color: theme.palette.getContrastText(theme.palette.action.hover),
      },
    },
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    count: {
      marginLeft: theme.spacing(0.5),
    },
  });

interface ReactButtonProps
  extends Omit<ButtonProps, 'classes'>,
    WithStyles<typeof styles> {
  iconComponent: ComponentType<SvgIconProps> | RemixiconComponentType;
  count?: number;
}

const ReactionButton = forwardRef<HTMLButtonElement, ReactButtonProps>(
  (props, ref) => {
    const {
      className,
      classes,
      iconComponent: IconComponent,
      count,
      size = 'medium',
      ...rest
    } = props;

    return (
      <Button
        variant={count && count > 0 ? 'outlined' : 'text'}
        className={classNames(classes?.root, className)}
        size={size}
        {...rest}
        ref={ref}
      >
        {IconComponent && <IconComponent className={classes?.icon} />}
        {count !== undefined && (
          <Text component="span" variant="body2" className={classes?.count}>
            {count}
          </Text>
        )}
      </Button>
    );
  },
);

ReactionButton.displayName = 'ActivityFeedItem.ReactionButton';

export default withStyles(styles)(ReactionButton);
